import Loading from '@/components/loading/loading';
import { Flex, Text } from '@cmpsr/components';
import React from 'react';
import useCompletedInterventionsController from './completed.controller';
import CompletedInterventionCard from './components/card';
import TrendCard from './components/trend-card';

function CompletedActionPlan() {
  const { interventions, isLoading } = useCompletedInterventionsController();

  if (!interventions) return false;
  if (isLoading) return <Loading />;

  return (
    <Flex direction="column" gap="spacer-6">
      {Object.keys(interventions).map((yearMonth, index) => (
        <Flex key={yearMonth} direction="column" gap="spacer-4">
          <Text variant="text-header-XS" textTransform="uppercase">
            {yearMonth}
          </Text>
          {interventions[yearMonth].map((intervention) => (
            <CompletedInterventionCard key={intervention.id} intervention={intervention} />
          ))}
          {index === 0 ? <TrendCard intervention={interventions[yearMonth][0]} /> : null}
        </Flex>
      ))}
    </Flex>
  );
}

export default React.memo(CompletedActionPlan);
